<header class="bg-white">
  <div>
    <div class="header">
      <a class="header--logo" href="{{ environment.websiteUrl }}" appHomeLink>
        <img src="./assets/img/logo.svg" alt="Logo Totalenergies" />
        <img
          *ngIf="partner$ | async as partner"
          [src]="partner.path"
          [alt]="partner.name"
          class="partner"
          (error)="handleMissingImage($event)"
        />
      </a>
      <div class="header--contacts flex">
        <div>
          <div class="font-sans text-xs font-bold text-primary pb-2">
            <div class="hidden md:block">
              <p [innerHTML]="'general.header.desktop.phoneNumber' | translate"></p>
            </div>
          </div>
          <div class="body-mention">
            <div class="hidden md:block">
              <p [innerHTML]="'general.header.desktop.hours' | translate"></p>
            </div>
          </div>
        </div>
        <div class="flex items-center sm:border-l-2 border-grey border-solid ml-8 pl-8">
          <app-lang-switcher></app-lang-switcher>
        </div>
      </div>
      <div class="header--title header--title--desktop">
        <h1 class="text-grey-dark h4 align-middle inline-block">{{ title.getTitle() }}</h1>
      </div>
    </div>
    <div class="header--title header--title--mobile">
      <h1 class="text-grey-dark h4 align-middle inline-block">{{ title.getTitle() }}</h1>
    </div>
  </div>
</header>
